var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonLink, Trans } from '@lucidlink/uicore';
import { MAIN_CONTENT_ID } from '#constants';
export const SkipLink = () => {
    const onSkip = (event) => {
        const mainContent = document.getElementById(MAIN_CONTENT_ID);
        if (mainContent) {
            event.preventDefault();
            mainContent.focus();
            mainContent.scrollIntoView();
        }
    };
    return (_jsx(ButtonLink, { "data-testid": "skip-to-main-content", isSkipLink: true, onClick: onSkip, to: `#${MAIN_CONTENT_ID}`, children: _jsx(Trans, { children: "Skip to main content" }) }));
};
_react_refresh_temp_1 = SkipLink;
$RefreshReg$(_react_refresh_temp_1, "SkipLink");
